export default __webpack_public_path__ + "static/SeheDeinenFortschrittselbst-909727d30a257bacf481490ae08337cb.svg";